import { supabase } from "../supabase";

const SUPABASE_PUBLIC_OBJECT =
  /\/storage\/v1\/object\/public\/([^/]+)\/(.+)$/i;

/** Set to "true" in .env if your Supabase project has Image Transformations (Pro+). */
const TRANSFORMS_ENABLED =
  process.env.REACT_APP_ENABLE_IMAGE_TRANSFORM === "true";

export const IMAGE_SIZES = {
  card: { width: 400, quality: 65 },
  thumb: { width: 140, quality: 60 },
  detail: { width: 900, quality: 75 },
  carousel: { width: 1200, quality: 75 },
  cart: { width: 100, quality: 60 },
};

/**
 * Returns a resized/compressed Supabase image URL when transforms are enabled,
 * otherwise the original URL (still benefits from upload-time WebP compression).
 */
export function getImageUrl(url, sizeKeyOrOptions = "card") {
  const fallback = url || "/thumbnail.png";
  if (!url || typeof url !== "string") return fallback;

  const options =
    typeof sizeKeyOrOptions === "string"
      ? IMAGE_SIZES[sizeKeyOrOptions] || IMAGE_SIZES.card
      : sizeKeyOrOptions;

  if (!TRANSFORMS_ENABLED || !options?.width) return url;

  const match = url.match(SUPABASE_PUBLIC_OBJECT);
  if (!match) return url;

  const [, bucket, encodedPath] = match;
  const filePath = decodeURIComponent(encodedPath);

  const { data } = supabase.storage.from(bucket).getPublicUrl(filePath, {
    transform: {
      width: options.width,
      quality: options.quality ?? 70,
      resize: options.resize ?? "cover",
    },
  });

  return data?.publicUrl || url;
}
